import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper/public-api';

@Component({
  selector: 'app-job-details-preview',
  templateUrl: './job-details-preview.component.html',
  styleUrls: ['./job-details-preview.component.scss']
})
export class JobDetailsPreviewComponent implements OnInit {


  images: any[] = [];
  videos: any[] = [];
  public clientsConfig: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 5,
    speed: 2000,
    spaceBetween: 15,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },
    keyboard: true,
    loop: false,
    longSwipes: true,
    // Disable preloading of all images
    preloadImages: false,
    // Enable lazy loading
    lazy: false,
    // autoplay: true,
    slidesOffsetAfter: 0,
    pagination: false,

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      240: {
        slidesPerView: 1,
      },
      600: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 1,
      },
      991: {
        slidesPerView: 1,
      },
      1200: {
        slidesPerView: 1,
      },
    },
  }

  public onIndexChange(index: number) {
  }

  constructor(
    public dialogRef: MatDialogRef<JobDetailsPreviewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  visibleImages: any[];
  remainingCount: number = 0;
  isModalOpen: boolean = false;
  currentImage: string = '';
  currentIndex: number = 0;
  showMap = false;


  ngOnInit(): void {



    this.visibleImages = this.data.clinicImages.slice(0, 4);


    if (this.data.clinicImages?.length > 0) {
      this.visibleImages = this.data.clinicImages.slice(0, 4);

      this.remainingCount = this.data.clinicImages.length - 3;
    }


  }

  openModal(index: number): void {
    this.currentIndex = index;
    this.currentImage = this.data.clinicImages[index].url;
    this.isModalOpen = true;
  }

  closeModal(): void {
    this.isModalOpen = false;
  }

  prevImage(): void {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.currentImage = this.data.clinicImages[this.currentIndex].url;
    }
  }

  nextImage(): void {
    if (this.currentIndex < this.data.clinicImages.length - 1) {
      this.currentIndex++;
      this.currentImage = this.data.clinicImages[this.currentIndex].url;
    }
  }

  openMap(): void {

    const location = this.data.elocation;


    const geocoder = new google.maps.Geocoder();

    geocoder.geocode({ address: location }, (results, status) => {
      if (status === 'OK' && results && results.length > 0) {
        const latLng = results[0].geometry.location;

        this.showMap = true;

        setTimeout(() => {
          const mapElement = document.getElementById('map');
          if (mapElement) {
            const map = new google.maps.Map(mapElement, {
              center: latLng,
              zoom: 4,
              mapTypeId: 'roadmap'
            });

            new google.maps.Marker({
              position: latLng,
              map,
              title: location
            });
          }
        }, 100);
      }
    });
  }

  onOutsideClick(event: MouseEvent) {
    this.showMap = false;
    this.isModalOpen = false;
  }


  formatUrl(url: string): string {
    if (!url) return '';
    return url.startsWith('http://') || url.startsWith('https://') ? url : `https://${url}`;
  }


  hasSocialMediaLinks(): boolean {
    const jd = this.data;
    return !!(jd?.facebook || jd?.instagram || jd?.linkedin);
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

}